import React, { useEffect, useState, useRef } from "react";
import { paymentMethods } from "../utils/helperFunctions";
const LayoutContext = React.createContext();

export const LayoutProvider = ({ children }) => {
    /* #region States */
    const [showHeader, setShowHeader] = useState(true); // Header
    const [showFooter, setShowFooter] = useState(false); // Footer
    const [showBOImagePageID, setShowBOImagePageID] = useState(""); // IF BOImage ourID is set, it will show the BOImage Page instead of the Feed Page in /feed route
    const [showMenuPanel, setShowMenuPanel] = useState(false); // Menu Panel
    const [locationLoader, setLocationLoader] = useState(false);
    // WINDOW WIDTH AND ISMOBILE
    const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Window Width
    const [isMobile, setIsMobile] = useState(windowWidth <= 992); // Is Mobile will be true if windowWidth is less than or equal to 992
    const [notDeliverCourier, setNotDeliverCourier] = useState(false);
    // Right Sidebar
    const [showRightSidebar, setShowRightSidebar] = useState(true); //  Right Sidebar
    const [showRightUserLocationPanel, setShowRightUserLocationPanel] = useState(false); // Right Sidebar User Location Panel
    const [showRightCheckoutPanel, setShowRightCheckoutPanel] = useState(false); // Right Sidebar Checkout Panel
    const [showRightMyOrdersPanel, setShowRightMyOrdersPanel] = useState(false); // Right Sidebar My Orders Panel
    const [showRightYourAccountPanel, setShowRightYourAccountPanel] = useState(false); // Right Sidebar Your Account Panel
    const [showRightAiPanel, setShowRightAiPanel] = useState(false); // Right Sidebar AI Panel
    const [showRightMyOrdersDetailsPanel, setShowRightMyOrdersDetailsPanel] = useState({
        orderID: null,
        isOpen: false
    });
    const [newLocationDetected, setNewLocationDetected] = useState(false);
    const [locationDismissed, setLocationDismissed] = useState(false);
    const [placeOrderLoadingAnimation, setPlaceOrderLoadingAnimation] = useState(false);
    const [storePanelData, setStorePanelData] = useState([]);
    const [deliveryPreference, setDeliveryPreference] = React.useState("fastest"); //fastest, cheapest
    const [showPaymentMethodPanel, setShowPaymentMethodPanel] = useState(false);

    // Right Sidebar My Orders Details Panel
    const [showRightSettingsPanel, setShowRightSettingsPanel] = useState(false); // Right Sidebar Settings Panel
    const [orderID, setOrderID] = useState(null); //orderID for see order status in thankyou panel
    const [footerLogoClicked, setFooterLogoClicked] = useState(false);

    // Popups
    const [showPolicyPopup, setShowPolicyPopup] = useState(false); // Policy Popup, can be "terms", "privacy" or "returns"
    const [showPaymentPopup, setShowPaymentPopup] = useState(false); // checkout payment popup
    const [showThankYouPopup, setShowThankyouPopup] = useState(false); //Show ThankYou popup
    const [showCourierInstructionPopup, setShowCourierInstructionPopup] = useState(false); //Courier Instruction Popup
    const [courierInstructionsData, setCourierInstructionsData] = useState({});
    const [showShareBOimagePopup, setShowShareBOimagePopup] = useState(false);
    const [showShippingAddressPopup, setShowShippingAddressPopup] = useState(false); // Shipping Address Popup
    const [shippingAddressPopupData, setShippingAddressPopupData] = useState(null); // Shipping Address Popup Data
    const [showConfirmBox, setShowConfirmBox] = React.useState(false);
    const [showYourAccountPannel, setShowYourAccountPannel] = useState(false); //Right Sidebar Your Account
    const [validatingPasswordToken, setValidatingPasswordToken] = useState(true);
    const [passwordIsChanged, setPasswordIsChanged] = useState(false);
    const [showLoginForm, setShowLoginForm] = useState(true);
    const [showRegistration, setShowRegistration] = useState(false);
    const [showPersonalInformation, setShowPersonalInformation] = useState(false);
    const [showCardInformation, setShowCardInformation] = useState(false);
    const [showPopOver, setShowPopOver] = useState(false);
    const [showReturnAndFeedBackPopup, setShowReturnAndFeedBackPopup] = useState(false); // Return and Feedback Popup
    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false); // Feedback Popup
    const [showReturnPopup, setShowReturnPopup] = useState(false); // Return Popup
    const [showReturnItemPopup, setShowReturnItemPopup] = useState(false); // Return Item Popup
    const [showFeedbackSubmittedPopup, setShowFeedbackSubmittedPopup] = useState(false); // Feedback Submitted Popup
    const [showReturnSubmittedPopup, setShowReturnSubmittedPopup] = useState(false); // Return Submitted Popup
    const [showSuggestPopup, setShowSuggestPopup] = useState(false);
    const [showSuggestStorePopup, setShowSuggestStorePopup] = useState(false);
    const [showQrPopup, setShowQrPopup] = useState(false);
    const [qrData, setQrData] = useState("");
    const [showBOPicpageID, setShowBOPicpageID] = useState("");
    const [paymentPopupData, setPaymentPopupData] = useState({
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        phoneNumber: undefined,
        nameOnCard: undefined
    });
    const [showInfoPopup, setShowInfoPopup] = useState({
        state: false,
        data: null,
        lastOpenState: false
    });
    //payment popup data
    const [stripeCardData, setStripeCardData] = useState({
        isCardNumber: false,
        isCardExpData: false,
        isCardCvv: false,
        isComplete: false
    });
    const [singleStoreData, setSingleStoreData] = useState(null);
    const [placeOrderLoading, setPlaceOrderLoading] = useState(false); // Place Order Loading
    const [cardPlaceOrderLoading, setCardPlaceOrderLoading] = useState(false); // Place Order Loading
    const [showPlacingOrderPopup, setShowPlacingOrderPopup] = useState(false); // Placing Order Popup
    const [showUserLoginRegisterPopup, setShowUserLoginRegisterPopup] = useState(false); // User Login Register  Popup
    const [showAccountUnsavedPopup, setShowAccountUnsavedPopup] = React.useState(false); // Account unsaved changes popup
    const [showAccountDeletePopup, setShowAccountDeletePopup] = useState(false); // Account Delete popup
    const [showForgotPasswordPopup, setShowForgotPasswordPopup] = useState(false);
    const [showPasswordForm, setShowPasswordForm] = useState(false);
    const [showCheckoutSuccessBlink, setShowCheckoutSuccessBlink] = useState(false);
    const [paymentLoading, setPaymentLoading] = useState(false);

    const [showBeacon, setShowBeacon] = useState(true); // State to hide and show beacons in footer
    const [showStoreInformation, setShowStoreInformation] = useState(false);
    const [storeInformation, setStoreInformation] = useState("");
    const [homeLoge, setHomeLogo] = useState(false);
    const [feedLogo, setFeedLogo] = useState(false);
    const [recentlyViewedImages, setRecentlyViewedImages] = useState([]);
    const [shareLocationSuccess, setShareLocationSuccess] = React.useState(true);
    const [showProductGalleryLightbox, setShowProductGalleryLightbox] = useState({
        isOpen: false,
        showProductDetails: true,
        slides: []
    }); // Product Gallery Lightbox
    const [quickBuyPopup, setQuickBuyPopup] = useState(false);
    const [fireworks, setFireworks] = useState([]);
    const [showFireWorks, setShowFireWorks] = useState(false);
    const [isCardPayment, setIsCardPayment] = useState(false);
    const mainContent = useRef(null);
    const [showStorePanel, setShowStorePanel] = useState(false);
    const [onFocusSearchBox, setOnFocusSearchBox] = useState(false);
    const [showFilterBox, setShowFilterBox] = useState(false);
    const [showFilterOption, setShowFilterOption] = useState(false);
    const [selectedType, setSelectedType] = useState("Posts");
    const [selectedGender, setSelectedGender] = useState("Both");
    const [selectedAgeGroup, setSelectedAgeGroup] = useState(["All"]);
    const [selectedColor, setSelectedColor] = useState("All");
    const [showImageType, setShowImageType] = useState(false);
    const [showGenderFilter, setShowGenderFilter] = useState(false);
    const [showAgeGroupFilter, setShowAgeGroupFilter] = useState(false);
    const [showColorFilter, setShowColorFilter] = useState(false);
    const [showBrandFilter, setShowBrandFilter] = useState(false);
    const [selectedPaymentType, setSelectedPaymentType] = useState(paymentMethods.CARD);
    const [activeBrandList, setActiveBrandList] = useState([]);
    const [selectedBrands, setSelectedBrands] = useState([]);
    const [selectedProductType, setSelectedProductType] = useState([]);
    const [showProductType, setShowProductType] = useState(false);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [selectedProductCategory, setSelectedProductCategory] = useState(["All"]);
    const [showProductCategory, setShowProductCategory] = useState(false);
    const [selectedDeliveryType, setSelectedDeliveryType] = useState([]); // Delivery Type
    const [showDeliveryFilter, setShowDeliveryFilter] = useState(false); // Delivery Filter
    const [searchText, setSearchText] = useState("");
    const [triggerSearch, setTriggerSearch] = useState(false);
    const [isSearchByAi, setIsSearchByAi] = useState(false);

    const [showTakePhotoPopup, setShowTakePhotoPopup] = useState(false);
    const [AIPanelNewFacebookPhoto, setAIPanelNewFacebookPhoto] = useState(null);
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        const handleWindowSizeChange = () => {
            setWindowWidth(window.innerWidth);
            setIsMobile(window.innerWidth <= 992);
        };

        window.addEventListener("resize", handleWindowSizeChange);

        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);
    useEffect(() => {}, [setSelectedBrands]);
    const urlParams = new URLSearchParams(window.location.search);
    const brands = urlParams.get("brands");
    useEffect(() => {
        if (brands) {
            setSelectedBrands(brands.split(","));
        }
    }, [setSelectedBrands, brands]);
    /* #endregion */

    return (
        <LayoutContext.Provider
            value={{
                showHeader,
                setShowHeader,
                showFooter,
                setShowFooter,
                showBOImagePageID,
                setShowBOImagePageID,
                showMenuPanel,
                setShowMenuPanel,
                windowWidth,
                isMobile,
                showRightSidebar,
                setShowRightSidebar,
                showRightUserLocationPanel,
                setShowRightUserLocationPanel,
                showRightCheckoutPanel,
                setShowRightCheckoutPanel,
                showRightAiPanel,
                setShowRightAiPanel,
                showRightMyOrdersPanel,
                setShowRightMyOrdersPanel,
                showRightYourAccountPanel,
                setShowRightYourAccountPanel,
                showPolicyPopup,
                setShowPolicyPopup,
                showShippingAddressPopup,
                setShowShippingAddressPopup,
                shippingAddressPopupData,
                setShippingAddressPopupData,
                showPaymentPopup,
                setShowPaymentPopup,
                paymentPopupData,
                setPaymentPopupData,
                stripeCardData,
                setStripeCardData,
                placeOrderLoading,
                setPlaceOrderLoading,
                placeOrderLoadingAnimation,
                setPlaceOrderLoadingAnimation,
                setShowThankyouPopup,
                showThankYouPopup,
                setShowUserLoginRegisterPopup,
                showUserLoginRegisterPopup,
                showRightMyOrdersDetailsPanel,
                setShowRightMyOrdersDetailsPanel,
                showRightSettingsPanel,
                setShowRightSettingsPanel,
                showYourAccountPannel,
                setShowYourAccountPannel,
                showAccountDeletePopup,
                setShowAccountDeletePopup,
                showConfirmBox,
                setShowConfirmBox,
                showForgotPasswordPopup,
                setShowForgotPasswordPopup,
                validatingPasswordToken,
                setValidatingPasswordToken,
                passwordIsChanged,
                setPasswordIsChanged,
                setShowPasswordForm,
                showPasswordForm,
                showLoginForm,
                setShowLoginForm,
                showRegistration,
                setShowRegistration,
                showPersonalInformation,
                setShowPersonalInformation,
                showCardInformation,
                setShowCardInformation,
                orderID,
                setOrderID,
                showCourierInstructionPopup,
                setShowCourierInstructionPopup,
                showAccountUnsavedPopup,
                setShowAccountUnsavedPopup,
                courierInstructionsData,
                setCourierInstructionsData,
                showBeacon,
                setShowBeacon,
                showShareBOimagePopup,
                setShowShareBOimagePopup,
                showStoreInformation,
                setShowStoreInformation,
                storeInformation,
                setStoreInformation,
                showPopOver,
                setShowPopOver,
                showReturnAndFeedBackPopup,
                setShowReturnAndFeedBackPopup,
                showFeedbackPopup,
                setShowFeedbackPopup,
                showReturnPopup,
                setShowReturnPopup,
                showReturnItemPopup,
                setShowReturnItemPopup,
                showFeedbackSubmittedPopup,
                setShowFeedbackSubmittedPopup,
                showReturnSubmittedPopup,
                setShowReturnSubmittedPopup,
                showQrPopup,
                setShowQrPopup,
                qrData,
                setQrData,
                cardPlaceOrderLoading,
                setCardPlaceOrderLoading,
                showProductGalleryLightbox,
                setShowProductGalleryLightbox,
                homeLoge,
                setHomeLogo,
                feedLogo,
                setFeedLogo,
                showSuggestPopup,
                setShowSuggestPopup,
                showSuggestStorePopup,
                setShowSuggestStorePopup,
                recentlyViewedImages,
                setRecentlyViewedImages,
                mainContent,
                shareLocationSuccess,
                setShareLocationSuccess,
                locationLoader,
                setLocationLoader,
                quickBuyPopup,
                setQuickBuyPopup,
                fireworks,
                setFireworks,
                showFireWorks,
                setShowFireWorks,
                showBOPicpageID,
                setShowBOPicpageID,
                footerLogoClicked,
                setFooterLogoClicked,
                notDeliverCourier,
                setNotDeliverCourier,
                showInfoPopup,
                setShowInfoPopup,
                showPlacingOrderPopup,
                setShowPlacingOrderPopup,
                showCheckoutSuccessBlink,
                setShowCheckoutSuccessBlink,
                isCardPayment,
                setIsCardPayment,
                showStorePanel,
                setShowStorePanel,
                storePanelData,
                setStorePanelData,
                singleStoreData,
                setSingleStoreData,
                deliveryPreference,
                setDeliveryPreference,
                newLocationDetected,
                setNewLocationDetected,
                locationDismissed,
                setLocationDismissed,
                onFocusSearchBox,
                setOnFocusSearchBox,
                showFilterBox,
                setShowFilterBox,
                showFilterOption,
                setShowFilterOption,
                selectedType,
                setSelectedType,
                selectedGender,
                setSelectedGender,
                selectedAgeGroup,
                setSelectedAgeGroup,
                showImageType,
                setShowImageType,
                showGenderFilter,
                setShowGenderFilter,
                showAgeGroupFilter,
                setShowAgeGroupFilter,
                selectedPaymentType,
                setSelectedPaymentType,
                selectedColor,
                setSelectedColor,
                showColorFilter,
                setShowColorFilter,
                activeBrandList,
                setActiveBrandList,
                selectedBrands,
                setSelectedBrands,
                showBrandFilter,
                setShowBrandFilter,
                selectedProductType,
                setSelectedProductType,
                showProductType,
                setShowProductType,
                selectedTypes,
                setSelectedTypes,
                showPaymentMethodPanel,
                setShowPaymentMethodPanel,
                paymentLoading,
                setPaymentLoading,
                selectedProductCategory,
                setSelectedProductCategory,
                showProductCategory,
                setShowProductCategory,
                selectedDeliveryType,
                setSelectedDeliveryType,
                showDeliveryFilter,
                setShowDeliveryFilter,
                searchText,
                setSearchText,
                triggerSearch,
                setTriggerSearch,
                isSearchByAi,
                setIsSearchByAi,

                showTakePhotoPopup,
                setShowTakePhotoPopup,
                AIPanelNewFacebookPhoto,
                setAIPanelNewFacebookPhoto
            }}>
            {children}
        </LayoutContext.Provider>
    );
};

export default LayoutContext;
